export default "__VITE_ASSET__dae27f3b__"